module.exports = __webpack_public_path__ + "static/media/course-javascript.78d1add2.JPG";